module.exports = __webpack_public_path__ + "static/media/Crispynoodles.5c280366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/Crispynoodles.jpg
// module id = 119
// module chunks = 0